import React, { memo, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AppSpinner from './AppSpinner';
import { downloadErrorSnapshotJPG, copyErrorSnapshotToClipboard } from '../utils/errorSnapshotExport';
import { productStaticAPI, timeseriesAPI, graphPrioEventsAPI, graphDeploymentEventsAPI } from "../http-common";
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import noThumbnail from "../images/noimage.png";

import '../styles/SingleGraph.css';
import "../styles/SynmonAnalyse.css";


const SynmonAnalyse = (props) => {
    console.log(props)
    /***
     *     __  ___      ___  ___  __
     *    /__`  |   /\   |  |__  /__`
     *    .__/  |  /~~\  |  |___ .__/
     *
     */
    const [isLoaded, setIsLoaded] = React.useState(false);                                       // Indikator ob Daten geladen wurden.       
    const [hasError, setHasError] = React.useState(false);                                       // Indikator ob Fehler vorliegen
    const [errorsIsLoaded, setErrorsIsLoaded] = React.useState(false);                                       // Indikator ob Daten geladen wurden.       
    const [errorsHasError, setErrorsHasError] = React.useState(false);                                       // Indikator ob Fehler vorliegen    
    const [hdImageIsLoaded, setHdImageIsLoaded] = React.useState(false);                                       // Indikator ob Daten geladen wurden.       
    const [hdImageHasError, setHdImageHasError] = React.useState(false);                                       // Indikator ob Fehler vorliegen        
    const [hdImage, setHdImage] = React.useState([]);                                                           // speichern des hdImages
    const [latestErrors, setLatestErrors] = React.useState([]);                                                // speichern der abgerufenen Error
    const selectedErrorIndex = React.useRef(0);
    const initialLoadingDone = React.useRef(0);
    const [okIsLoaded, setOkIsLoaded] = React.useState(false);                                               // Indikator ob Daten geladen wurden.       
    const [okHasError, setOkHasError] = React.useState(false);                                               // Indikator ob Fehler vorliegen    
    const [okData, setOkData] = React.useState([]);                                                           // speichern des ok Objekts
    const [graphIsLoaded, setGraphIsLoaded] = React.useState(false);                                         // Indikator ob Daten geladen wurden.       
    const [graphIsShown, setGraphIsShown] = React.useState(false);                                           // Indikator ob ein Graph angezeigt wird
    // Facelift: State für Screenshot-Zoom via Klick. null = kein Zoom,
    // 'error' = Fehler-Screenshot vergrößert, 'ok' = OK-Screenshot vergrößert.
    const [zoomedImage, setZoomedImage] = React.useState(null);
    const [graphHasError, setGraphHasError] = React.useState(false);                                         // Indikator ob Fehler vorliegen    
    const [options, setOptions] = React.useState(null);                                          // Options holds the options for the Highcharts
    const ref = React.useRef();
    const seriesCount = React.useRef(0);
    const prioCount = React.useRef(0);
    const deploymentCount = React.useRef(0);

    /***
     *          __   ___     ___  ___  ___  ___  __  ___  __
     *    |  | /__` |__     |__  |__  |__  |__  /  `  |  /__`
     *    \__/ .__/ |___    |___ |    |    |___ \__,  |  .__/
     *
     */

    React.useEffect(() => {
        fetchAllErrors();
        fetchOkData();
    }, []);


    /***
     *     ___            __  ___    __        __
     *    |__  |  | |\ | /  `  |  | /  \ |\ | /__`
     *    |    \__/ | \| \__,  |  | \__/ | \| .__/
     *
     */

    /* *******************************************************************************************************************************************
    /*                            Funktionen zum Handling der Error Screenshots & Infos
    /* ****************************************************************************************************************************************** */

    const switchError = (index) => {
        console.log("Switch to Error Index: " + index)
        selectedErrorIndex.current = index
        fetchAllErrors();
    }

    const fetchAllErrors = async () => {
        //setErrorsIsLoaded(false);
        setErrorsHasError(false);

        const endpointURL = "/"+ props.data.data.productID +"/tests/"+ props.data.data.testID +"/errors"
        const idToken = props.receiveIDToken();
        const headers = { 'Authorization': idToken };

        const allErrors = await productStaticAPI.get(endpointURL, {headers})
        .then(response => {   
            console.log("response:")
            console.log(response)
            let obj = {
              data:  response.data
            };
            setErrorsIsLoaded(true);
            setErrorsHasError(false);
            setLatestErrors(obj);
            fetchHdImage(response.data[selectedErrorIndex.current]._id);
            return obj
        })
        .catch(function (error) {
          console.log("Fetch issue: get all errors " +error)
          props.handleNotify({type: 'alert', message: "Fehler beim Abrufen der letzten Crit Messungen"})
          let obj = {
            data:  []
          };
          setErrorsIsLoaded(true);
          setErrorsHasError(true);
          setHdImageIsLoaded(true);
          setHdImageHasError(true)
          setLatestErrors(obj);
          return (obj)
        });          
    }

    const fetchHdImage = async (errorID) => {
        console.log("Get HD Image for: " + errorID)
        setHdImageIsLoaded(false);
        setHdImageHasError(false);

        const endpointURL = "/"+ props.data.data.productID +"/tests/"+ props.data.data.testID +"/errors/"+errorID+"/screenshot"
        const idToken = props.receiveIDToken();
        const headers = { 'Authorization': idToken };

        const hdImage = await productStaticAPI.get(endpointURL, {headers})
        .then(response => {   
            console.log("response HD:")
            console.log(response)
            let obj = {
              data:  response.data
            };
            setHdImageIsLoaded(true);
            setHdImageHasError(false);
            setHdImage(obj);
            return obj
        })
        .catch(function (error) {
          console.log("Fetch issue: get all errors " +error)
          props.handleNotify({type: 'alert', message: "Fehler beim Abrufen des letzten Fehler Screenshots"})
          let obj = {
            data:  []
          };
          setHdImageIsLoaded(true);
          setHdImageHasError(true);
          setHdImage(obj);
          return (obj)
        });          
    }   
    
    const fetchOkData = async () => {
        
        setOkIsLoaded(false);
        setOkHasError(false);

        const endpointURL = "/"+ props.data.data.productID +"/tests/"+ props.data.data.testID +"/oks"
        const idToken = props.receiveIDToken();
        const headers = { 'Authorization': idToken };

        const okData = await productStaticAPI.get(endpointURL, {headers})
        .then(response => {   
            console.log("response:")
            console.log(response)
            let obj = {
              data:  response.data
            };
            setOkIsLoaded(true);
            setOkHasError(false);
            setOkData(obj);
            return obj
        })
        .catch(function (error) {
          console.log("Fetch issue: get ok Status " +error)
          props.handleNotify({type: 'alert', message: "Fehler beim Abrufen des letzten OK Status"})
          let obj = {
            data:  []
          };
          setOkIsLoaded(true);
          setOkHasError(true);
          setOkData(obj);
          return (obj)
        });          
    }     

    /* *******************************************************************************************************************************************
    /*                            Funktionen zum Handling des Detail Graphen
    /* ****************************************************************************************************************************************** */
    const endpointURL = "/"+ props.data.data.productID +"/tests/"+ props.data.data.testID +"/performance?grouped=false"

    const fetchData = async () => {
        const idToken = props.receiveIDToken();
        const headers = { 'Authorization': idToken };

        const res = await timeseriesAPI.get(endpointURL, {headers});

        const prioEvents = await graphPrioEventsAPI.get("", {headers})
        .then(response => {
          
          if(props.showPrioFlags === true){
            let obj = {
              data:  response.data
            };
            return obj
          } else {
            let obj = {
              data:  []
            };
            return (obj)          
          }        
        })
        .catch(function (error) {
          console.log("Fetch error prio events" +error)
          props.handleNotify({type: 'alert', message: "Fehler beim Abrufen der Flags: Priostörungen"})
          let obj = {
            data:  []
          };
          return (obj)
        });
  
        //console.log("prioevents:")
        //console.log(prioEvents)
  
        const deploymentEvents = await graphDeploymentEventsAPI.get("", {headers})
        .then(response => {
          if(props.showDeploymentFlags === true){
            let obj = {
              data:  response.data
            };
            return obj
          } else {
            let obj = {
              data:  []
            };
            return (obj)          
          }        
        })
        .catch(function (error) {
          console.log("Fetch error deployment events" + error)
          props.handleNotify({type: 'alert', message: "Fehler beim Abrufen der Flags: Deployments"})
          let obj = {
            data:  []
          };
          return (obj)
        });
      
        //console.log("Loaded Prio:")
        //console.log(prioEvents.data)
  
        //console.log(res)      
        const result = {
            status: res.status + "-" + res.statusText,
            headers: res.headers,
            data: res.data,
            prio: prioEvents.data,
            deployments: deploymentEvents.data          
        };
  
        /*
        console.log("PrioData:")
        console.log(result.prio)
        console.log("deployments:")
        console.log(result.deployments)
        */
  
        return result
      }

    const showDetailGraph = () => {
        setGraphIsShown(true)
        setGraphIsLoaded(false)
                
        const fetchRecords = async () => {
          
            const idToken = props.receiveIDToken();
            const headers = { 'Authorization': idToken };
            const res = await timeseriesAPI.get(endpointURL, {headers});
  
            const prioEvents = await graphPrioEventsAPI.get("", {headers})
            .then(response => {

                let obj = {
                  data:  response.data
                };
                return obj
      
            })
            .catch(function (error) {
              console.log("Fetch error prio events" +error)
              props.handleNotify({type: 'alert', message: "Fehler beim Abrufen der Flags im Detailgraphen: Priostörungen"})
              let obj = {
                data:  []
              };
              return (obj)
            });          
  
  
            const deploymentEvents = await graphDeploymentEventsAPI.get("", {headers})
            .then(response => {

                let obj = {
                  data:  response.data
                };
                return obj
 
            })          
            .catch(function (error) {
              console.log("Fetch error deployment events" + error)
              props.handleNotify({type: 'alert', message: "Fehler beim Abrufen der Flags im Detailgraphen: Deployments"})
              let obj = {
                data:  []
              };
              return (obj)
            });
            
            const result = {
                status: res.status + "-" + res.statusText,
                headers: res.headers,
                data: res.data,
                prio: prioEvents.data,
                deployments: deploymentEvents.data
            };
  
            // Hard-Floor fuer die "< X -> immer rot"-Zone. Werte unter diesem
            // Schwellenwert gelten als Ausfall/kein-Messwert und werden rot dargestellt,
            // unabhaengig von den user-editierbaren thresholds. Identisch zu SingleGraph.
            const HARD_MIN_THRESHOLD = 0.005;

            const minCrit = props.data.data.ok;
            const warn = props.data.data.warn;
            const crit = props.data.data.crit;
            //const minCrit = 0;
            //const warn = 100;
            //const crit = 120;            
            const graphTitel = null;
            const subTitel = null;            
            const graphEinheit = 'sek.';
            const PlotLabelColor = 'var(--PlotLabelColorCustom)';

            // Wenn User minCrit auf 0/leer setzt, auf HARD_MIN_THRESHOLD hochziehen
            // damit die Zone-Sortierung [HARD_MIN_THRESHOLD, effectiveMinCrit, warn, crit]
            // aufsteigend bleibt.
            const effectiveMinCrit = Math.max(Number(minCrit) || 0, HARD_MIN_THRESHOLD);

            // y=0 (Ausfall) auffaellig hervorheben: pro Datenpunkt roten Kreis-Marker
            // ueberschreiben. Analog SingleGraph.
            const zeroPointMarker = {
                enabled: true,
                radius: 3,
                fillColor: '#df002e',
                lineWidth: 0,
                symbol: 'circle'
            };
            const enhancedData = (result.data || []).map(function(point){
                if(Array.isArray(point)){
                    if(point[1] === 0){
                        return { x: point[0], y: 0, marker: zeroPointMarker };
                    }
                    return point;
                }
                if(point && typeof point === 'object' && point.y === 0){
                    return { ...point, marker: zeroPointMarker };
                }
                return point;
            });
  
            /// Setting the Highstock options variable
            setOptions({
              
              title: {
                text: graphTitel,
                style: {
                  color: 'white',
                  fontWeight: 'bold'
                }
              },
  
              subtitle: {
                  text: subTitel,
                  style: {
                      color: 'white',
                  }
              },
  
              scrollbar: {
                barBackgroundColor: 'var(--subtext-color)',
                barBorderRadius: 5,
                barBorderWidth: 0,
                buttonBackgroundColor: 'var(--subtext-color)',
                buttonBorderWidth: 0,
                buttonBorderRadius: 5,
                trackBackgroundColor: 'var(--hover-color)',
                trackBorderWidth: 0,
                trackBorderRadius: 6,
                trackBorderColor: '#CCC'
              },
  
              chart: {
                zoomType: 'x',
                backgroundColor: 'transparent',
                reflow: true,
                
              events: {
                  load: function () {
                      
                      let series = this.series[0];
                      let prioSeries = this.series[1];
                      let deploymentSeries = this.series[2]; 
                      // Highcharts v12: `series.xData`/`yData` sind nicht mehr
                      // öffentlich gepflegt (lazy getter über `series.getColumn`).
                      // Für einen reinen Count reicht `series.data.length`, was
                      // für die anderen beiden Serien hier ohnehin schon genutzt
                      // wird.
                      seriesCount.current = series.data.length;
                      prioCount.current = prioSeries.data.length;
                      deploymentCount.current = deploymentSeries.data.length; 
                     
                          fetchData().then(
                            function(value) {
                              /*
                              console.log("value:")
                              console.log(value)
                              
                              console.log("series: ")
                              console.log(series)
          
                              console.log("PrioSeries: ")
                              console.log(prioSeries)
          
                              console.log("deploymentSeries: ")
                              console.log(deploymentSeries)  
                              */
  
                              //--------------------------------------------
                              // Prüfen ob neue Values des Graphen vorliegen
                              //--------------------------------------------
                              const oldLength = seriesCount.current;
                              //console.log("Series: ")
                              //console.log(series)
                              const newLength = value.data.length;
                              //console.log("Value: ")
                              //console.log(value)                            
  
                              if(oldLength !== newLength){
                                  console.log("Neue Daten für Graphen gefunden.")
                                  const newPoints = newLength - oldLength;
                                  const newStart = newLength - newPoints;
                                  
                                  console.log("Old Length: " + oldLength)
                                  console.log("New Length: " + newLength)
                                  console.log("New Points: " + newPoints)
                                  console.log("New Start: " + newStart)
                                  
                                  if(newPoints < 10){
                                    for(let i = 0; i < newPoints; i++ ){
                                        
                                        let getFrom = newStart;                                    
                                        console.log("Add Data: " + value.data[getFrom])
                                        series.addPoint([value.data[getFrom][0], value.data[getFrom][1]], true, true);
                                        getFrom++
  
                                    }
                                    seriesCount.current = newLength
                                  } else {
                                    console.log("Zuviele neue Messungen. Seite refreshen!")    
                                  }
  
                              } else {
                                //console.log("Keine neuen Daten vorhanden.")
                              }
  
                              //--------------------------------------------
                              // Prüfen ob neue Daten der Priostörungen vorliegen
                              //--------------------------------------------  
                              
                              const prioOldLength = prioCount.current;
                              const prioNewLength = value.prio.length;
  
                              /*
                              console.log("PrioOld: ")
                              console.log(prioCount.current) 
                              console.log("PrioNew: " + prioNewLength)
                              */
  
                              if(prioOldLength !== prioNewLength){
                                  console.log("Neue Daten für Priostörungen gefunden.")
                                  const prioNewPoints = prioNewLength - prioOldLength;
                                  const prioNewStart = prioNewLength - prioNewPoints;
  
                                  if(prioNewPoints < 10){
                                    for(let i = 0; i < prioNewPoints; i++ ){
                                        
                                        let prioGetFrom = prioNewStart;                                    
                                        console.log("Add Prio: " + value.prio[prioGetFrom])
                                        prioSeries.addPoint({x: value.prio[prioGetFrom]['x'] ,title: value.prio[prioGetFrom]['title'],text: value.prio[prioGetFrom]['text']});
                                        prioGetFrom++
  
                                    }
                                    prioCount.current = prioNewLength
                                  } else {
                                    console.log("Zuviele neue Einträge bei den Priostörungen. Seite refreshen!")    
                                  }
  
                              } else {
                                //console.log("Keine neuen Priostörungen vorhanden.")
                              }   
                              
                              //--------------------------------------------
                              // Prüfen ob neue Daten der Deployments vorliegen
                              //--------------------------------------------  
                              
                              const deploymentsOldLength = deploymentCount.current;
                              const deploymentsNewLength = value.deployments.length;
  
                              if(deploymentsOldLength !== deploymentsNewLength){
                                  console.log("Neue Daten für Priostörungen gefunden.")
                                  const deploymentsNewPoints = deploymentsNewLength - deploymentsOldLength;
                                  const deploymentsNewStart = deploymentsNewLength - deploymentsNewPoints;
  
                                  if(deploymentsNewPoints < 10){
                                    for(let i = 0; i < deploymentsNewPoints; i++ ){
                                        
                                        let deploymentsGetFrom = deploymentsNewStart;                                    
                                        console.log("Add Deployment: " + value.deployments[deploymentsGetFrom])
                                        deploymentSeries.addPoint({x: value.deployments[deploymentsGetFrom]['x'] ,title: value.deployments[deploymentsGetFrom]['title'],text: value.deployments[deploymentsGetFrom]['text']});
                                        deploymentsGetFrom++
  
                                    }
                                    deploymentCount.current = deploymentsNewLength
                                  } else {
                                    console.log("Zuviele neue Einträge bei den Deployments. Seite refreshen!")    
                                  }
  
                              } else {
                                //console.log("Keine neuen Deployments vorhanden.")
                              }                             
  
                            },
                            function(error) {
                              console.log("Error beim Updaten des Graphen")
                              console.log(error)
                              setHasError(true)
                            }
                          )                        
  

  
                  }
                }
                
              },
  
              yAxis: [{
                opposite:false,															              // Linke Seite für die Label festlegen
                gridLineColor: 'var(--subtext-color)',
                labels: {
                    formatter: function() {
                      return this.value + ' ' + graphEinheit;							// Übergebene Einheit
                    },
                    style: {
                        color: PlotLabelColor
                    }
                },
  
                title: {
                    text: 'Durchlaufzeit in ' + graphEinheit,
                },
  
                plotLines: [{
                    color: '#e6be00', 														        // Color value
                    dashStyle: 'shortdash', 												      // Style of the plot line. Default to solid
                    value: warn, 															            // Value of where the line will appear
                    width: 1, 																            // Width of the line
                    label: {
                        text: 'Warnung: ' + warn + ' ' + graphEinheit,		// Content of the label.
                        align: 'left', 														        // Positioning of the label.
                        style: {
                            color: PlotLabelColor,												// Fontcolor
                            'font-size': 'xx-small'
                        }
                    }
                },{
                    color: '#df002e', 														        // Color value
                    dashStyle: 'shortdash', 												      // Style of the plot line. Default to solid
                    value: crit,															            // Value of where the line will appear
                    width: 1, 																            // Width of the line
                    label: {
                        text: 'Kritisch: ' + crit + ' ' + graphEinheit,		// Content of the label.
                        align: 'left', 														        // Positioning of the label.
                        style: {
                            color: PlotLabelColor,												// Fontcolor
                            'font-size': 'xx-small'
                        }
                    }
                }]
              }],
  
  
              xAxis: [{
                gridLineWidth: 0,
                minorGridLineWidth: 0,
                labels: {
                    style: {
                      color: PlotLabelColor
                    }
                }
              }],
  
              rangeSelector: {
                  buttonTheme: { 
                    fill: 'none',
                    stroke: 'none',
                    'stroke-width': 0,
                    r: 8,
                    style: {
                        color: 'var(--subtext-color)',
                        fontWeight: 'bold'
                    },
                    states: {
                        hover: {
                          fill: 'var(--hover-color)',
                            style: {
                                color: 'white'
                            }
                        },
                        select: {
                            fill: 'var(--hover-color)',
                            style: {
                                color: 'white'
                            }
                        }
                    }
                  },
                  inputStyle: {
                    color: 'var(--subtext-color)',
                    fontWeight: 'bold'
                  },
                  selected: 3,
                  inputEnabled: true,
                  inputDateFormat: '%d.%m.%Y',
                  buttons: [{
                      type: 'hour',
                      count: 6,
                      text: '6h',
                      events: {
                          click: function() {
  
                          }
                      }
                  },{
                      type: 'hour',
                      count: 12,
                      text: '12h',
                      events: {
                          click: function() {
  
                          }
                      }
                  },{
                      type: 'day',
                      count: 1,
                      text: '1d',
                      events: {
                          click: function() {
  
                          }
                      }
                  },{
                      type: 'week',
                      count: 1,
                      text: '1w',
                      events: {
                          click: function() {
  
                          }
                      }
                  },{
                      type: 'week',
                      count: 3,
                      text: '3w',
                      events: {
                          click: function() {
  
                          }
                      }
                  },{
                      type: 'all',
                      text: 'All'
                  }]
              },    
  
  
              plotOptions: {
                  line: {
                      dataLabels: {
                          enabled: false
                      },
                  }
              },
  
              series: [
                  {
                      name : 'Antwortzeit',
                      turboThreshold: 11000,
                      data: enhancedData,
                      id: 'dataseries',
  
                      zones: [{															      // Festlegen in welchen Bereichen Alarmiert wird
                        // Hard-Floor: Werte < HARD_MIN_THRESHOLD (0.005) werden immer rot
                        // dargestellt, unabhaengig von den dynamischen thresholds
                        // (Ausfall / kein gueltiger Messwert).
                        value: HARD_MIN_THRESHOLD,
                        color: '#df002e'
                      }, {
                        value: effectiveMinCrit,										// Bei y-Wert bis minCrit = crit (rot); effectiveMinCrit = max(minCrit, HARD_MIN_THRESHOLD)
                        color: '#df002e'
                      },{
                        value: warn,														  // Bei y-Wert bis warn = warnung (gelb)
                        color: '#84bc34'
                      }, {
                        value: crit,														  // Bei y-Wert ab crit = kritisch (rot)
                        color: '#e6be00'
                      }, {
                        color: '#df002e'													// sonst (grÃ¼n)
                    }],
  
                    dataGrouping: {
                      dateTimeLabelFormats: {
                          millisecond: ['%A, %e. %B, %Y %H:%M:%S', '%A, %e. %B, %Y %H:%M', ' - %H:%M'],
                          second: ['%A, %e. %B, %Y %H:%M:%S', '%A, %e. %B, %Y %H:%M', ' - %H:%M'],
                          minute: ['%A, %e. %B, %Y %H:%M:%S', '%A, %e. %B, %Y %H:%M', ' - %H:%M'],
                          hour: ['%A, %e. %B, %Y %H:%M:%S', '%A, %e. %B, %Y %H:%M', ' - %H:%M'],
                          day: ['%A, %e. %B, %Y %H:%M:%S', '%A, %e. %B, %Y %H:%M', ' - %H:%M'],
                          week: ['%A, %e. %B, %Y %H:%M:%S', '%A, %e. %B, %Y %H:%M', ' - %H:%M'],
                          month: ['%A, %e. %B, %Y %H:%M:%S', '%A, %e. %B, %Y %H:%M', ' - %H:%M'],
                          year: ['%A, %e. %B, %Y %H:%M:%S', '%A, %e. %B, %Y %H:%M', ' - %H:%M']
                      }
                  },
  
                  marker: {
                    symbol: 'circle',
                    states: {
                        hover: {
                            fillColor: 'white',
                            lineColor: 'white',
                            lineWidth: 3
                        }
                    }
                  },
  
                  shadow: true,
                  tooltip: {
                      xDateFormat: '%A, %e. %B, %Y %H:%M:%S',
                      // pointFormatter statt pointFormat: bei y === 0 (Testlauf ohne
                      // gueltige Durchlaufzeit) ein eigener Text, statt irrefuehrend
                      // 'Durchlaufzeit: 0 sek.' anzuzeigen. Analog SingleGraph.
                      pointFormatter: function() {
                          if(this.y === 0){
                              return '<p style="font-size:11px;">Testlauf fehlgeschlagen<br/>';
                          }
                          return '<p style="font-size:11px;">Durchlaufzeit: <b>' + this.y.toFixed(2) + '</b> ' + graphEinheit + '<br/>';
                      }
                      // Hinweis: backgroundColor/borderColor/borderRadius/borderWidth
                      // sind in Highcharts v12 im Stock-Chart-Split-Modus no-ops;
                      // der Style kommt vom globalen `Highcharts.setOptions({ tooltip: ... })`
                      // (gesetzt in SingleGraph.jsx / MiniGraph.jsx, gilt global).
                  },               
  
                  },
                  {
                    type: 'flags',
                    fillColor: "#5F86B3",
                    cursor: 'pointer',
                    name: 'Flags in pane',
                    data: result.prio,
                    onSeries: 'dataseries',
                    style: { // text style
                        color: 'white',
                    },
                    states: {
                        hover: {
                            fillColor: '#395C84', // darker
                            lineColor: 'white'
                        },
                        normal: {
                            fillColor: '#395C84', // darker
                            lineColor: 'white'
                        }
                    },
  
                    point: {
                        events: {
                            click: function () {
                                window.open(this.link, '_blank');
                            }
                        }
                    }
  
                  },
                  {
                    type: 'flags',
                    fillColor: "#d09344",
                    cursor: 'pointer',
                    name: 'Flags in pane',
                    data: result.deployments,
                    onSeries: 'dataseries',
                    style: { // text style
                        color: '#000000',
                    },
                    states: {
                        hover: {
                            fillColor: '#d09344', // darker
                            lineColor: '#000000'
                        },
                        normal: {
                            fillColor: '#d09344', // darker
                            lineColor: '#000000'
                        }
                    },
  
                    point: {
                        events: {
                            click: function () {
                                window.open(this.html_url, '_blank');
                            }
                        }
                    }
                  }
              ],
  
              credits: {
                  enabled: false
              },
  
              accessibility: {
                enabled: false
              },
  
              exporting: {
                  enabled: false
              }
            });
  
            setIsLoaded(true); 
        }
  
        fetchRecords().catch(function (error) {
          if (error.response) {
            setHasError(true)
            console.log("ERROR! Request made and server responded")
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            setHasError(true)
            console.log("ERROR! The request was made but no response was received")
            console.log(error.request);
          } else {
            setHasError(true)
            console.log("ERROR! Something happened in setting up the request that triggered an Error")
            console.log('Error', error.message);
          }
        })        
    }

    /***
     *     __   __            __   ___ ___       __
     *    |  \ /  \  |\/|    |__) |__   |  |  | |__) |\ |
     *    |__/ \__/  |  |    |  \ |___  |  \__/ |  \ | \|
     *
     */

    // Facelift: ESC-Handler zum Schließen des Screenshot-Zooms (Bonus zum Klick).
    React.useEffect(() => {
        if (zoomedImage === null) return;
        const onKey = (e) => {
            if (e.key === 'Escape') setZoomedImage(null);
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [zoomedImage]);

    // ------------------------------------------------------------------------
    // Fehler-Snapshot-Export (Download JPG / Copy PNG to Clipboard). Nutzt den
    // Canvas-Renderer in utils/errorSnapshotExport.js. Keine externe Library.
    // ------------------------------------------------------------------------
    const [isExporting, setIsExporting] = React.useState(false);

    const buildExportMeta = React.useCallback(() => {
        const currentError = errorsIsLoaded && latestErrors?.data?.length > 0
            ? latestErrors.data[selectedErrorIndex.current]
            : null;
        const productData = props?.data?.data || {};
        return {
            productName:    productData.productName || '',
            testName:       productData.testName || '',
            productID:      productData.productID || '',
            testID:         productData.testID || '',
            errorTimestamp: currentError?.created || '',
            errorShort:     currentError?.errorShort || '',
            exportedAt:     new Date().toLocaleString('de-DE'),
        };
    }, [errorsIsLoaded, latestErrors, props]);

    const sanitizeFilename = (input) => String(input || 'snapshot').replace(/[^a-z0-9-_]+/gi, '_');

    const handleDownloadSnapshot = React.useCallback(async () => {
        if (isExporting) return;
        if (!hdImage?.data) {
            props.handleNotify?.({ type: 'alert', message: 'Kein Screenshot verfügbar.' });
            return;
        }
        setIsExporting(true);
        try {
            const meta = buildExportMeta();
            const stamp = new Date().toISOString().replace(/[:.TZ]/g, '-').slice(0, 15);
            const fname = `fehleranalyse_${sanitizeFilename(meta.productName)}_${sanitizeFilename(meta.testName)}_${stamp}.jpg`;
            await downloadErrorSnapshotJPG(meta, hdImage.data, fname);
            props.handleNotify?.({ type: 'success', message: 'Snapshot heruntergeladen.' });
        } catch (err) {
            console.error(err);
            props.handleNotify?.({ type: 'alert', message: 'Snapshot-Erzeugung fehlgeschlagen.' });
        } finally {
            setIsExporting(false);
        }
    }, [isExporting, hdImage, buildExportMeta, props]);

    const handleCopySnapshot = React.useCallback(async () => {
        if (isExporting) return;
        if (!hdImage?.data) {
            props.handleNotify?.({ type: 'alert', message: 'Kein Screenshot verfügbar.' });
            return;
        }
        setIsExporting(true);
        try {
            const meta = buildExportMeta();
            await copyErrorSnapshotToClipboard(meta, hdImage.data);
            props.handleNotify?.({ type: 'success', message: 'Fehlerinformationen in Zwischenspeicher kopiert.' });
        } catch (err) {
            console.error(err);
            props.handleNotify?.({ type: 'alert', message: 'Kopieren in Zwischenablage fehlgeschlagen (Browser-API nicht verfügbar?).' });
        } finally {
            setIsExporting(false);
        }
    }, [isExporting, hdImage, buildExportMeta, props]);

    return (
    <>
        <div className="synmonAnalyseWrap">
            <div className="synmonAnalyseContent">

                {/* ============ Header ============ */}
                <header className="synmonAnalyse--Header">
                    <div className="synmonAnalyse--HeaderTitleWrap">
                        <h1 className="synmonAnalyse--HeaderTitle">Synthetisches Monitoring · Fehleranalyse</h1>
                        <div className="synmonAnalyse--HeaderSub">
                            <span>{props.data?.data?.productName}&nbsp;·&nbsp;{props.data?.data?.testName}</span>
                            {errorsIsLoaded && latestErrors?.data?.length > 0 && latestErrors.data[selectedErrorIndex.current] && (
                                <>
                                    <span className="synmonAnalyse--HeaderSubDot"></span>
                                    <span className="synmonAnalyse--HeaderSubLabel">Fehler-Zeitpunkt:</span>
                                    <span className="synmonAnalyse--HeaderErrTime">
                                        {latestErrors.data[selectedErrorIndex.current].created}
                                    </span>
                                </>
                            )}
                        </div>
                    </div>
                    <button
                        type="button"
                        className="synmonAnalyse--CloseBtn"
                        onClick={() => props.handleToggleSynmonAnalyse()}
                        title="Schließen"
                        aria-label="Schließen"
                    >
                        <FontAwesomeIcon icon="fa-regular fa-rectangle-xmark" />
                    </button>
                </header>

                {/* ============ Content ============ */}
                <div className="synmonAnalyse--Content">

                    {/* Reihe 1: Timeline (links) + Fehlerdetails (rechts), fix und kompakt */}
                    <div className="synmonAnalyse--TopRow">

                        {/* Linke Spalte: Fehler-Auswahl-Timeline */}
                        <div className="synmonAnalyse--TopRowCol">
                            <div className="synmonAnalyse--SectionHead">
                                <h2>Zeitleiste der letzten Fehler</h2>
                                {errorsIsLoaded && latestErrors?.data?.length > 0 && (
                                    <span className="synmonAnalyse--SectionMeta">
                                        {latestErrors.data.length} Fehler · Auswahl per Klick
                                    </span>
                                )}
                                <div className="synmonAnalyse--HeaderActions">
                                    <button
                                        type="button"
                                        className="synmonAnalyse--CapBtn"
                                        onClick={handleCopySnapshot}
                                        disabled={isExporting || !hdImageIsLoaded || !hdImage?.data}
                                        title="Snapshot in Zwischenablage – anschliessend in Jira Ctrl+V"
                                        aria-label="Snapshot in Zwischenablage kopieren"
                                    >
                                        <FontAwesomeIcon icon="fa-regular fa-copy" />
                                        <span>Kopieren</span>
                                    </button>
                                    <button
                                        type="button"
                                        className="synmonAnalyse--CapBtn"
                                        onClick={handleDownloadSnapshot}
                                        disabled={isExporting || !hdImageIsLoaded || !hdImage?.data}
                                        title="Snapshot als JPG-Datei herunterladen"
                                        aria-label="Snapshot als JPG herunterladen"
                                    >
                                        <FontAwesomeIcon icon="fa-solid fa-download" />
                                        <span>Download JPG</span>
                                    </button>
                                </div>
                            </div>
                            <div className="synmonAnalyse--Timeline">
                                {
                                    (() => {
                                        if (errorsIsLoaded === false)
                                            return(
                                                <div className="productWidget--LoadingWrap">
                                                    <p className="productWidget--LoadingWrapText">Lade Daten</p>
                                                    <p><AppSpinner /></p>
                                                </div>
                                            )
                                        if (errorsHasError === true)
                                            return <div className="productWidget--ErrorWrap">Fehlerhafte Daten</div>
                                        if (latestErrors.length <= 0)
                                            return <div className="productWidget--ErrorWrap">Keine Fehler gefunden</div>
                                        else
                                            return(
                                                latestErrors.data.map((position, index) => {
                                                    let thumbnail = ""
                                                    if(position.image.length > 0){
                                                        thumbnail = position.image
                                                    } else {
                                                        thumbnail = noThumbnail
                                                    }
                                                    const isActive = index === selectedErrorIndex.current;
                                                    return(
                                                        <div
                                                            key={position._id}
                                                            className={"synmonAnalyse--Thumb" + (isActive ? " synmonAnalyse--Thumb-Active" : "")}
                                                            onClick={() => switchError(index)}
                                                        >
                                                            <div className="synmonAnalyse--ThumbImage">
                                                                <img src={thumbnail} alt="" className="thumbnailImageStyle" />
                                                            </div>
                                                            <div className="synmonAnalyse--ThumbDate">{position.created}</div>
                                                        </div>
                                                    )
                                                })
                                            )
                                    })()
                                }
                            </div>
                        </div>

                        {/* Rechte Spalte: Fehlerdetails */}
                        <div className="synmonAnalyse--TopRowCol">
                            <div className="synmonAnalyse--SectionHead">
                                <h2>Fehlerdetails</h2>
                            </div>
                            <div className="synmonAnalyse--ErrDetails">
                                {errorsIsLoaded && latestErrors?.data?.length > 0 && latestErrors.data[selectedErrorIndex.current] ? (
                                    <>
                                        <div className="synmonAnalyse--ErrHeader">
                                            <span className="synmonAnalyse--ErrHeaderLabel">Fehler:</span>
                                            <span className="synmonAnalyse--ErrHeaderShort">
                                                {latestErrors.data[selectedErrorIndex.current].errorShort}
                                            </span>
                                        </div>
                                        <div className="synmonAnalyse--Stack">
                                            {latestErrors.data[selectedErrorIndex.current].errorShort}
                                        </div>
                                    </>
                                ) : (
                                    <div className="productWidget--ErrorWrap">Keine Fehlerdetails verfügbar</div>
                                )}
                            </div>
                        </div>

                    </div>

                    {/* Reihe 2: Vergleich Fehler ↔ Letzter OK (nimmt gesamten übrigen Vertikalraum) */}
                    <div className="synmonAnalyse--SectionHead">
                        <h2>Vergleich: Fehler-Zeitpunkt vs. Letzter OK-Zustand</h2>
                    </div>
                    <div className="synmonAnalyse--Compare">

                        {/* Fehler-Screenshot */}
                        <div className="synmonAnalyse--ScreenshotCard">
                            <div className="synmonAnalyse--ScreenshotCap">
                                <span className="synmonAnalyse--Badge synmonAnalyse--Badge-Err">⚠ Fehler-Zeitpunkt</span>
                                {errorsIsLoaded && latestErrors?.data?.length > 0 && latestErrors.data[selectedErrorIndex.current] && (
                                    <span className="synmonAnalyse--Ts">
                                        {latestErrors.data[selectedErrorIndex.current].created}
                                    </span>
                                )}
                            </div>
                            <div className="synmonAnalyse--ScreenshotBody">
                            {
                                (() => {
                                    if (hdImageIsLoaded === false)
                                        return(
                                            <div className="productWidget--LoadingWrap">
                                                <p className="productWidget--LoadingWrapText">Lade Daten</p>
                                                <p><AppSpinner /></p>
                                            </div>
                                        )
                                    if (hdImageHasError === true)
                                        return <div className="productWidget--ErrorWrap">Fehlerhafte Daten</div>
                                    if (hdImage.length <= 0)
                                        return <div className="productWidget--ErrorWrap">Keine HD Screen vorhanden</div>
                                    if (hdImage.data.length <= 0)
                                        return <div className="productWidget--ErrorWrap">Kein Fehler Screenshot vorhanden</div>
                                    else
                                        return (
                                            <>
                                                <img
                                                    src={hdImage.data}
                                                    alt=""
                                                    className="hdImageStyle"
                                                    onClick={() => setZoomedImage('error')}
                                                />
                                                {zoomedImage === 'error' && (
                                                    <div
                                                        className="synmonAnalyse--ZoomOverlay"
                                                        onClick={() => setZoomedImage(null)}
                                                        role="button"
                                                        aria-label="Vergrößerung schließen"
                                                        tabIndex={0}
                                                    >
                                                        <img src={hdImage.data} alt="" />
                                                    </div>
                                                )}
                                            </>
                                        )
                                })()
                            }
                            </div>
                        </div>

                        {/* OK-Screenshot */}
                        <div className="synmonAnalyse--ScreenshotCard">
                            <div className="synmonAnalyse--ScreenshotCap">
                                <span className="synmonAnalyse--Badge synmonAnalyse--Badge-Ok">✓ Letzter OK</span>
                                {okIsLoaded && okData?.data && okData.data.created && (
                                    <span className="synmonAnalyse--Ts">{okData.data.created}</span>
                                )}
                            </div>
                            <div className="synmonAnalyse--ScreenshotBody">
                            {
                                (() => {
                                    if (okIsLoaded === false)
                                        return(
                                            <div className="productWidget--LoadingWrap">
                                                <p className="productWidget--LoadingWrapText">Lade Daten</p>
                                                <p><AppSpinner /></p>
                                            </div>
                                        )
                                    if (okHasError === true)
                                        return <div className="productWidget--ErrorWrap">Fehlerhafte Daten</div>
                                    if (okData.length <= 0)
                                        return <div className="productWidget--ErrorWrap">Keine HD Screen vorhanden</div>
                                    if (okData.data.length <= 0 || okData.data.image.length <= 0)
                                        return <div className="productWidget--ErrorWrap">Kein OK Screenshot vorhanden</div>
                                    else
                                        return (
                                            <>
                                                <img
                                                    src={okData.data.image}
                                                    alt=""
                                                    className="hdImageStyle"
                                                    onClick={() => setZoomedImage('ok')}
                                                />
                                                {zoomedImage === 'ok' && (
                                                    <div
                                                        className="synmonAnalyse--ZoomOverlay"
                                                        onClick={() => setZoomedImage(null)}
                                                        role="button"
                                                        aria-label="Vergrößerung schließen"
                                                        tabIndex={0}
                                                    >
                                                        <img src={okData.data.image} alt="" />
                                                    </div>
                                                )}
                                            </>
                                        )
                                })()
                            }
                            </div>
                        </div>

                    </div>

                    {/* Reihe 3: Detail-Graphen über volle Breite (Lazy per Klick).
                        Standardmäßig ist die Row kompakt (nur SectionHead + Load-Button).
                        Nach Klick auf "Laden" wird die Row via --Expanded-Klasse auf
                        volle Höhe geschaltet; X-Button in der SectionHead schließt wieder. */}
                    <div className="synmonAnalyse--SectionHead">
                        <h2>Metriken zum Fehler-Zeitpunkt</h2>
                        {graphIsShown && (
                            <button
                                type="button"
                                className="synmonAnalyse--GraphCloseBtn"
                                onClick={() => setGraphIsShown(false)}
                                title="Detail-Graphen schließen"
                                aria-label="Detail-Graphen schließen"
                            >
                                <FontAwesomeIcon icon="fa-solid fa-xmark" />
                            </button>
                        )}
                    </div>
                    <div className={"synmonAnalyse--GraphRow" + (graphIsShown ? " synmonAnalyse--GraphRow-Expanded" : "")}>
                        {
                            (() => {
                                if (graphIsShown === false)
                                    return(
                                        <div className="synmonAnalyse--GraphEmpty">
                                            <button
                                                type="button"
                                                className="synmonAnalyse--LoadGraphBtn"
                                                onClick={() => showDetailGraph()}
                                            >
                                                <FontAwesomeIcon icon="fa-solid fa-chart-line" /> Detail-Graphen laden
                                            </button>
                                            <div className="synmonAnalyse--GraphHint">
                                                Zeitreihen zum Fehler-Zeitpunkt werden bei Bedarf nachgeladen.
                                            </div>
                                        </div>
                                    )
                                if (isLoaded === false)
                                    return(
                                        <div className="productWidget--LoadingWrap">
                                            <p className="productWidget--LoadingWrapText">Lade Daten</p>
                                            <p><AppSpinner /></p>
                                        </div>
                                    )
                                if (hasError === true)
                                    return <div className="productWidget--ErrorWrap">Fehlerhafte Daten</div>
                                else
                                    return(
                                        <div className="synmonAnalyse--GraphChart">
                                            <HighchartsReact
                                                highcharts={Highcharts}
                                                constructorType={'stockChart'}
                                                options={options}
                                                allowChartUpdate={true}
                                                containerProps={{ style: { height: "100%" } }}
                                            />
                                        </div>
                                    )
                            })()
                        }
                    </div>

                </div>
            </div>
        </div>
    </>
    )
}

export default memo(SynmonAnalyse);


